import httpManager from "@/app/shared/utils/httpManager";

export async function activateMassManagement(data) {
  const response = await httpManager.put("/settings/add-to-massive/", data);
  return response.data;
}
